import MaterialTable from '@material-table/core'
import { Typography } from '@mui/material'
import EmtpyReview from './EmtpyReview'
import React from 'react'
import { useContext } from 'react'
import { withTranslation } from 'react-i18next'
import { BsChevronRight } from 'react-icons/bs'
import { ReviewContext } from './reviewContext'

function ReviewsTable({ branchesRatings }) {
    const { setShowComment, setCurrentBranch } = useContext(ReviewContext)
    const cellStyles = {
        fontWeight: '400',
        fontSize: '16px',
        lineHeight: '24px'
    }
    return (
        <div className='flex flex-col w-full'>
            <div className='text-[#05213D] font-[700] text-md '>
                <div className='m-0 p-0'><span style={{ fontSize: '40px' }}> {Number(branchesRatings?.data?.rating).toFixed(2)}</span> out of 5
                    <span className='ml-[40px] inline-block'>{branchesRatings?.data?.total} Reviews</span> </div>
            </div>
            {
                branchesRatings?.data?.branches?.length ?  <MaterialTable
                title=''
                columns={[
                    { title: 'Branch Name', field: 'name', render: (data) => <Typography sx={{ ...cellStyles }}>{data.name}</Typography> },
                    { title: 'Branch Location', field: 'location', render: (data) => <Typography sx={{ ...cellStyles }}>{data.location}</Typography> },
                    { title: 'Ratings', field: 'rating', render: (data) => <Typography sx={{ ...cellStyles }}>{Number(data.rating).toFixed(2)}</Typography> },
                    { title: 'Reviews', field: 'total', render: (data) => <Typography sx={{ ...cellStyles }}>{data.total}</Typography> },
                ]}
                data={branchesRatings?.data?.branches || []}
                options={{
                    actionsColumnIndex: -1,
                    search: false,
                    headerStyle: {
                        lineHeight: '21px',
                        fontSize: '14px',
                        fontWeight: '700',
                        color: '#657585'
                    }
                }}
                localization={{
                    header: {
                        actions: ''
                    }
                }}
                actions={[
                    {
                        icon: () => <BsChevronRight />,
                        tooltip: 'View details',
                        onClick: (event, rowData) => { setCurrentBranch(rowData); setShowComment(true); }
                    }
                ]}
            /> : <EmtpyReview />
           }
        </div>
    )
}

export default withTranslation()(ReviewsTable)